import { Heading1, Heading4 } from '@ovotech/nebula';
import styled, { css } from 'styled-components';
import { mqMediumUp } from '../../../utils/mediaQuery';

const responsiveFontSizes = css`
  font-size: 32px !important;
  ${mqMediumUp(`
    font-size: 48px !important;
  `)}
`;

export const HeaderTitle = styled(Heading1)<{
  useResponsiveSizes?: boolean;
}>`
  color: white;
  margin-top: 2.3rem !important;
  ${({ useResponsiveSizes }) => {
    if (useResponsiveSizes) {
      return responsiveFontSizes;
    }
    return `font-size: clamp(2.5rem, 2vw + 1rem, 3.8rem) !important;`;
  }}
`;

export const HeaderDescription = styled(Heading4)`
  color: white;
  margin-bottom: 25px !important;
`;

export const SmallHeaderTitle = styled(Heading4)`
  color: white;
  margin-top: 2.3rem !important;
`;
